import { ReactElement, useState } from "react"
import cn from "classnames"

import { Sizes } from "../interfaces"
import { SIZES } from "../constant"

interface Props {
    src: string
    size?: Sizes
    className?: string
    alt?: string
    fallback: () => ReactElement
}

export function ImgAvatar({ src, size, alt, className, fallback }: Props) {
    const [error, setError] = useState(false)
    if (error) return fallback()

    return (
        <img
            src={src}
            alt={alt || "avatar"}
            srcSet={`${src} 2x`}
            style={size ? SIZES[size] : undefined}
            className={cn("circle", className)}
            onError={() => setError(true)}
        />
    )
}
